var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2C1.5 1.72386 1.72386 1.5 2 1.5H10.5C10.7761 1.5 11 1.72386 11 2C11 2.27614 10.7761 2.5 10.5 2.5H2.5V13.5H13.5V5C13.5 4.72386 13.7239 4.5 14 4.5C14.2761 4.5 14.5 4.72386 14.5 5V14C14.5 14.2761 14.2761 14.5 14 14.5H2C1.72386 14.5 1.5 14.2761 1.5 14V2Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L6.14645 9.14645C5.95118 9.34171 5.95118 9.65829 6.14645 9.85355C6.34171 10.0488 6.65829 10.0488 6.85355 9.85355L14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.85111d12627cb0fcd94c0923e67353eb.svg";
export { ForwardRef as ReactComponent };